<template>
  <user-center-slot>
    <user-center-container-slot>
      <!-- 左侧菜单栏 -->
      <!-- 左侧菜单栏 -->
      <user-center-menu />

      <user-center-content-slot :hidden="true">
        <user-center-content-title title="基本信息" />
        <div class="user-center__info-row">
          <div class="user-center__info-portrait">
            <div v-show="isEdit">
              <template v-if="ruleForm.headPictureUrl">
                <img :src="this.$baseURL + 'vul/hsrc/vul/report/servlet/res/image?attachmentId=' + ruleForm.headPictureUrl" class="user-center__info-pic" />
              </template>
              <template v-else>
                <i class="iconfont icon-touxiang user-center__info-pic user-center__info-pic--default"></i>
              </template>
            </div>
            <div v-show="!isEdit" class="user-center__info-portrait-upload">
              <div>
                <div>
                  <xui-upload
                    class="xui-upload--text"
                    :action="action"
                    :headers="xCsrfToken"
                    :on-error="reportError"
                    :limit="1"
                    :before-upload="beforUploadZip"
                    show-overflow-tooltip
                    :on-exceed="handleExceed"
                    :on-success="handlePreview"
                    :with-credentials="true"
                  >
                    <div>
                      <template v-if="ruleForm.headPictureUrl">
                        <img :src="this.$baseURL + 'vul/hsrc/vul/report/servlet/res/image?attachmentId=' + ruleForm.headPictureUrl" class="user-center__info-pic" />
                      </template>
                      <template v-else>
                        <i class="iconfont icon-touxiang user-center__info-pic user-center__info-pic--default"></i>
                      </template>
                    </div>
                    <div class="user-center__info-button--default">上传头像</div>
                  </xui-upload>
                </div>
              </div>
              <div class="user-center__info-portrait-tips">支持jpg、png、gif、jpeg格式图片，大小不超过2M</div>
            </div>
            <div class="user-center__info-portrait-txt" @click="openDialog">退出奖励计划</div>
            <div>
              贡献值：<span class="user-center__info-portrait-txt--inner">{{ ruleForm.donate }}</span>
            </div>
          </div>
          <div>
            <a v-show="editFlag" class="user-center__info-button--primary" href="javascript:void(0);" @click="onEdit">修改资料</a>
          </div>
        </div>
        <!-- <div class="user-center__user-info-title">
              <span class="user-center__user-info-title-txt">贡献值：{{ ruleForm.donate }}</span>
            </div> -->
        <!-- 展示部分 -->
        <div v-show="isEdit">
          <div class="user-center__info-list">
            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">昵称：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.displayName }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">签名：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.signature }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">团队：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.team }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">主页：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.homePage }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">邮箱：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.email }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">QQ/微信：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.qq }}</div>
            </div>
            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">邮寄地址：</div>
              <div class="user-center__info-item-content is-overflow-hidden">{{ ruleForm.mailingAddress }}</div>
            </div>

            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">英雄榜展示：</div>
              <div class="user-center__info-item-content is-overflow-hidden">
                <template>
                  <span v-if="ruleForm.showRanking == '1'">参与</span>
                  <span v-else>不参与</span>
                </template>
              </div>
            </div>
            <div class="user-center__info-item is-overflow-hidden">
              <div class="user-center__info-item-title">个人资质附件：</div>
              <div v-show="null != ruleForm.qualiAttachId && '' !== ruleForm.qualiAttachId" class="user-center__info-item-content is-overflow-hidden">
                <span> <i class="fa fa-file"></i> </span>
                <xui-link 
                  :key="index"
                  class="attachment_uploadFile_xui-link" 
                  :href="url2" 
                  :disabled="!disabledFlag"
                  type="primary"
                  :title="ruleForm.docName"
                  target="_blank">
                    {{ docNameHandle(ruleForm.docName) }} 
                    <span v-if="uploadMsg2 =='您上传的文件正在扫描中...'" class="upload-msg">
                      {{ uploadMsg2 }}
                    </span>
                    <span v-else-if="uploadMsg2 !='您上传的文件正在扫描中...'" style="color:red;">
                      {{ uploadMsg2 }}
                    </span>
                </xui-link>
              </div>
            </div>
            <!-- <xui-row class="user-info-item line">
                <xui-col :span="24" class="item-title">英雄榜排名:</xui-col>
                <xui-col :span="24" class="item-value">
                  <xui-switch v-model="ruleForm.showRanking" :disabled="true" :active-value="1" :inactive-value="0"> </xui-switch>
                  <span style="margin-left:20px;color: #606266;"> ON-英雄榜昵称展示</span></xui-col
                >
              </xui-row> -->

            <!-- <xui-row class="user-info-item line">
                <xui-col :span="24" class="item-title">贡献值:</xui-col>
                <xui-col :span="24" class="item-value"></xui-col>
              </xui-row> -->

            <!-- <xui-row class="user-info-item user-info-item-ranking line ">
                <xui-col :span="24" class="item-title">英雄榜排名:</xui-col>
                <xui-col :span="24" class="item-value line">
                  <div role="switch" aria-disabled="true" class="xui-switch is-disabled">
                    <input type="checkbox" name="" true-value="true" disabled="disabled" class="xui-switch__input">
                    <span class="xui-switch__core" style="width: 40px;">
                    </span>
                  </div>
                  <span class="line-tip">OFF-英雄榜匿名展示</span>
                </xui-col>
              </xui-row> -->
          </div>
        </div>
        <!-- 编辑部分 -->
        <div v-show="!isEdit">
          <xui-form ref="ruleForm" class="user-center__info-list" :model="ruleForm" :rules="rules">
            <div class="user-center__info-item">
              <div class="user-center__info-item-title is-required">昵称:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="displayName">
                  <xui-input v-model.trim="ruleForm.displayName" placeholder="请输入您的昵称"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">签名:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="signature">
                  <xui-input v-model.trim="ruleForm.signature" placeholder="请输入您的个性签名"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">团队:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="team">
                  <xui-input v-model.trim="ruleForm.team" :disabled="true" placeholder="请输入您的团队名称"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">主页:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="homePage">
                  <xui-input v-model.trim="ruleForm.homePage" :maxlength="128" placeholder="请输入您的主页地址"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">邮箱:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="email">
                  <xui-input v-model.trim="ruleForm.email" type="email" placeholder="请输入您的邮箱" @change="email = emailCheck(email)"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">QQ/微信:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="qq">
                  <xui-input v-model.trim="ruleForm.qq" placeholder="请输入您的QQ账号"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">邮寄地址:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="mailingAddress">
                  <xui-input v-model.trim="ruleForm.mailingAddress" :maxlength="1000" placeholder="请输入您的邮寄地址"></xui-input>
                </xui-form-item>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">英雄榜展示:</div>
              <div class="user-center__info-item-content">
                <xui-select v-model="ruleForm.showRanking" placeholder="请选择">
                  <xui-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </xui-option>
                </xui-select>
              </div>
            </div>

            <div class="user-center__info-item">
              <div class="user-center__info-item-title">个人资质附件:</div>
              <div class="user-center__info-item-content">
                <xui-form-item class="is-success" prop="docName">
                  <xui-upload
                      class="upload_width report__form-upload"
                      :action="actionZip"
                      :headers="xCsrfToken"
                      :file-list="fileData"
                      :limit="1"
                      :on-error="reportError"
                      :on-remove="resetFile"
                      show-overflow-tooltip
                      accept=".doc, .docx, .xlsx,.jpg, .jpeg, .png, .gif,.bmp,.txt,.7z,.rar,.zip,.pdf"
                      :before-upload="beforUploadFile"
                      :on-exceed="handleExceed"
                      :on-success="handlePreviewZip"
                      :with-credentials="true"
                    >
                      <a id="uploadZip" class="report__form-button--upload" href="javascript:void(0);">选择文件</a>
                      <div slot="tip" class="user-center__info-item-tips">
                        格式限制:doc, docx, xlsx,jpg, jpeg, png, gif,bmp,txt,7z,rar,zip,pdf格式,不超过10M。 <span v-if="this.uploadMsg =='您上传的文件正在扫描中...'" class="upload-msg"> {{ uploadMsg }} </span>
                        <span v-else-if="this.uploadMsg !='您上传的文件正在扫描中...'" style="color:red;"> {{ uploadMsg }} </span>
                      </div>
                    </xui-upload>
                </xui-form-item>
              </div>
            </div>
            <!-- <xui-row class="user-setting-item xui-row--flex line">
                <xui-col :span="4" class="item-title"> 英雄榜排名: </xui-col>
                <xui-col :span="16" class="item-value">
                  <xui-form-item class="is-success">
                    <xui-switch v-model="ruleForm.showRanking" :active-value="1" :inactive-value="0"> </xui-switch> <span style="margin-left:20px;color: #606266;"> ON-英雄榜昵称展示</span>
                  </xui-form-item>
                </xui-col>
              </xui-row> -->

            <!-- <xui-row class="user-setting-item xui-row--flex line">
                <xui-col :span="4" class="item-title"> 英雄榜排名: </xui-col>
                <xui-col :span="16" class="item-value">
                  <xui-form-item class="is-success">
                    <xui-switch v-model="ruleForm.showRanking" :active-value="1" :inactive-value="0"> </xui-switch> <span style="margin-left:20px;color: #606266;"> ON-英雄榜昵称展示</span>
                  </xui-form-item>
                </xui-col>
              </xui-row> -->

            <!-- <xui-row class="user-setting-item xui-row--flex line">
                <xui-col :span="4" class="item-title">
                  贡献值:
                </xui-col>
                <xui-col :span="16" class="item-value">
                  <xui-form-item class="is-success" prop="signature">
                    <div class="nochange-value" style="font-size:14px">0</div>
                  </xui-form-item>
                </xui-col>
              </xui-row> -->

            <!-- <xui-row class="user-setting-item xui-row--flex line">
                <xui-col :span="4" class="item-title">
                  英雄榜排名:
                </xui-col>
                <xui-col :span="16" class="item-value">
                  <xui-form-item class="nochange-value is-required" prop="level">
                    <xui-switch v-model="ruleForm.isOn">
                    </xui-switch>
                    <span class="line-tip">{{ruleForm.isOn ? 'ON' : 'OFF'}}-英雄榜匿名展示</span>
                  </xui-form-item>
                </xui-col>
              </xui-row> -->
          </xui-form>
          <div class="user-center__info-submit">
            <xui-button type="primary" class="user-center__info-button--bottom" :disabled="submitDisabled" @click="onSubmit('ruleForm')">
              <span> 提交 </span>
            </xui-button>
          </div>
        </div>
      </user-center-content-slot>
    </user-center-container-slot>
    <!-- 修改个人资料结果提示弹框 -->
    <xui-dialog title="" :close-on-click-modal="false" showcenter :visible.sync="delWarnning" width="30%">
      <p class="dialog-content">
        <span>
          <template v-if="success">
            <img class="img-status" src="../../../images/settingSuccess.jpg" />
          </template>
          <template v-else>
            <img class="img-status" src="../../../images/settingError.png" />
          </template>
        </span>
      </p>
      <p class="dialog-content">
        <span>
          {{ success ? '您的个人资料保存成功！' : '您的个人资料保存失败！！' }}
        </span>
      </p>
    </xui-dialog>
    <!-- 荣耀安全应急响应中心服务条款弹框 -->
    <xui-dialog title="" class="warnning-wrap" :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" :width="$store.state.isMobile ? '80%' : '30%'" :before-close="handleClose">
      <h3 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' }">荣耀安全应急响应中心服务条款</h3>
      <div class="content-wrap" :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
        <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
        <ul>
          <li>真实姓名，身份证正反面照片及身份证号；</li>
          <li>银行卡号，开户行信息，银行名称；</li>
          <li>手机号码，邮寄地址；</li>
          <li>昵称，头像，邮箱，主页；</li>
          <li>QQ，微信，签名，团队；</li>
          <li>IP地址；</li>
          <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
        </ul>
        <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
        <span
          >点击“同意”，即表示您同意
          <a :href="safetyURL" target="_blank" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
          ，并知悉
          <a :href="privacyURL" target="_blank" class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span
        >
      </div>
      <span slot="footer" class="dialog-footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-if="cancelDialog" title="提醒" class="login-dialog-cancel" :close-on-click-modal="false" showcenter :visible.sync="cancelDialog" width="30%" @close="cancelDialog = false">
      <span>
        <xui-icon class="dialog_span-icon" icon="fa fa-exclamation-triangle"></xui-icon
       >确定选择退出，系统将删除您在荣耀安全响应中心平台所有的个人数据。（若您是团队队长，建议您先将团队队长转让给其他团队成员，我们会在您退出奖励计划的同时将你所在的团队队长转让给其他团队成员，若当前团队仅有您自己时，团队将会解散）</span
      >
      <br />
      <span>是否确认退出？</span> <br />
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="logout">确定</xui-button>
        <xui-button size="bigger" @click="cancelDialogMethod">取消</xui-button>
      </span>
    </xui-dialog>

    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>

    <!-- 登录提示弹框 -->
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>
  </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu';
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot';
import UserCenterSlot from '../../../components/pages/UserCenterSlot';
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot';
import UserCenterContentTitle from '../../../components/pages/UserCenterContentTitle';
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import { mapState } from 'vuex';
import store from '../../../store/index';

export default {
  name: 'usercenterInfo',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
    UserCenterContentTitle
  },
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  data() {
    return {
      safetyURL: '',
      privacyURL: '',
      editFlag: true,
      options2: [
        {
          value: 0,
          label: '不参与'
        },
        {
          value: 1,
          label: '参与'
        }
      ],
      userInfoVO: {},
      url2:'',
      disabledFlag: true,
      isEffect: false,
      xCsrfToken: null,
      isNotLogin: false,
      dialogVisible: false,
      uploadMsg2: '',
      uploadMsg: '',
      submitDisabled: false,
      isEdit: true,
      action: this.$baseURL + 'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadImg&dir=image',
      actionZip: this.$baseURL +'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadAttach&dir=VulAttach&businessType=USER_QUALI_ATTACH', // 上传附件，压缩包
      ruleForm: {
        headPictureUrl: null,
        qq: '',
        donate: 0,
        qualiAttachId:'', 
        mailingAddress: '',
        showRanking: 1
      },
      originForm: {},
      rules: {
        displayName: [
          { required: true, message: '昵称不能为空', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          { min: 0, max: 15, message: '最大输入长度15', trigger: 'change' }
        ],
        signature: [
          { min: 0, max: 60, message: '最大输入长度60', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        team: [
          { min: 0, max: 60, message: '最大输入长度60', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        homePage: [
          { min: 0, max: 128, message: '最大输入长度128', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (value) {
                const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
                if (!reg.test(value)) {
                  callback(new Error('URL格式错误'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        email: [
          { type: 'email', required: false, message: '请输入正确的邮件地址', trigger: 'change' },
          { min: 0, max: 128, message: '最大输入长度128', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if(value && value.indexOf('@') > -1){
                const splitVal = value.split('@');
                // eslint-disable-next-line no-magic-numbers
                if(splitVal[0].length > 64){
                  callback(new Error('请输入正确的用户信箱账号'));
                }else{
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        qq: [
          { required: false, message: '请输入QQ/微信', trigger: 'change' },
          { min: 5, max: 20, message: '最小输入长度5,最大输入长度20', trigger: 'change' }
        ],
        mailingAddress: [
          { required: false, message: '请输入您的邮寄地址', trigger: 'change' },
          {
            validator: function(rule, value, callback) {
              if (/[<>&\\"']/.test(value) == true) {
                callback(new Error('请不要输入特殊字符'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
      },
      delWarnning: false,
      success: true,
      qqCount: 1,
      personal1:false,
      personal:null,
      cancelDialog: false,
      pollingDataInterval: null,
      fileData:[],
      arrMsg: [
        '您上传的文件无病毒',
        '检测到上传的附件存在病毒',
        '您上传的文件文件加密',
        '',
        '当前杀毒云系统扫描存在异常，可能原因为压缩包存在密码，建议下载文件后进行手工查杀'
      ],
      nullMsg: {
        displayName: '昵称不能置空！',
        signature: '签名不能置空！',
        team: '团队不能置空！',
        homePage: '主页不能置空！',
        email: '邮箱不能置空！',
        qq: 'QQ/微信不能置空！',
        mailingAddress: '邮寄地址不能置空！',
        qualiAttachId:'个人资质不能为空！'
      }
    };
  },
  mounted() {
    setTimeout(() => {
      this.safetyURL = window.sessionStorage.getItem('safetyURL');
      this.privacyURL = window.sessionStorage.getItem('privacyURL');
      this.getCSRF();
      this.getUserInfo();
    }, 100);
  },
  beforeDestroy() {
    if (this.pollingDataInterval) {
      clearInterval(this.pollingDataInterval);
    }
  },
  methods: {
    getDataUrl(){
      console.log('item', this.userInfoVO)
      this.uploadMsg2 = '';
      this.disabledFlag = true;
      let url = 'javascript:;';
      const Token = window.sessionStorage.getItem('x-csrf-token');
      if(null == this.userInfoVO.qualiAttachId || '' === this.userInfoVO.qualiAttachId){
        return;
      }
      this.$http.get(`vul/hsrc/vul/report/services/filetask/single?attachmentId=` + this.userInfoVO.qualiAttachId, { headers: { 'x-csrf-token': Token } }).then(res => {
        if (res && res.data && res.data.status === 200) {
          const data = res.data.data;
          let uploadMsg2 = '';
          if (Number(data) > 5) {
            uploadMsg2 = '您上传的文件正在扫描中...';
            this.disabledFlag = false;
          } else {
            this.arrMsg.forEach((e, i) => {
              if (Number(data) === i + 1) {
                uploadMsg2 = e;
              }
            });
          if (uploadMsg2 === '检测到上传的附件存在病毒') {
              this.disabledFlag = false;
            } else {
              this.disabledFlag = true; 
              url = `https://${this.$baseU}.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/download?dlType=QualiAttachFiles&attachmentId=` + this.userInfoVO.qualiAttachId;
            }
          }
          this.uploadMsg2 = `${uploadMsg2}`;
          this.url2 = url;
          this.$forceUpdate();
        }
      });
    },
    openLogoutUrl() {
      const hostType = window.location.host;
      if (hostType === 'security.honor.com') {
        window.open('//hnid-drcn.cloud.honor.com/AMW/portal/userCenter/index.html#/settings', '_blank');
      } else {
        window.open('//hnid-test-drcn.cloud.honor.com/AMW/portal/userCenter/index.html#/settings', '_blank');
      }
    },
    beforUploadZip(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      const extension = testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'gif';
      const isList10M = file.size / 1024 / 1024 < 2;
      let bool = false;

      if (extension) {
        bool = true;
      } else {
        bool = false;
      }

      if (!extension) {
        this.$message.warning('上传文件只能是jpg,jpeg,png,gif格式');
      }
      if (!isList10M) {
        this.$message.warning('上传文件大小不能超过2M!');
      }
      return bool && isList10M;
    },
    //上传资料
    beforUploadFile(file) {
      // return new Promise((resolve, reject) => {
        const testmsg = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();//取后缀名且文件格式全部小写
        const extension = testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'gif'|| testmsg === 'doc'|| testmsg === 'docx'|| testmsg === 'xlsx'|| testmsg === 'bmp'|| testmsg === 'txt'|| testmsg === '7z'|| testmsg === 'rar'|| testmsg === 'zip'|| testmsg === 'pdf';
        const isList10M = file.size / 1024 / 1024 < 10;
        let bool = false;

        if (extension) {
          bool = true;
        } else {
          bool = false;
        }

        if (!extension) {
          this.$message.warning('上传文件只能是doc, docx, xlsx,jpg, jpeg, png, gif,bmp,txt,7z,rar,zip,pdf格式');
        }
        if (!isList10M) {
          this.$message.warning('上传文件大小不能超过10M!');
        }
        // resolve(bool && isList10M);
        return bool && isList10M;
      // });
    },
    //扫毒
    handlePreviewZip(file) {
      if(null == file[0] || '' === file[0]){
        return;
      }
      this.uploadMsg = '您上传的文件正在扫描中...';
      this.submitDisabled = false;
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.ruleForm.qualiAttachId = file[0];
      this.pollingDataInterval = setInterval(() => {
        this.$http
          .get(`vul/hsrc/vul/report/services/filetask/single?attachmentId=${file[0]}`, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            if (res.data && res.data.status === 200) {
              const data = res.data.data;
              if (Number(data) > 5) {
                console.log("已扫描超过五次")
              } else {
                this.arrMsg.forEach((e, i) => {
                  if (Number(data) === i + 1) {
                    this.uploadMsg = e;
                  }
                });
                if(this.uploadMsg === '检测到上传的附件存在病毒'){
                  this.submitDisabled = true;
                } else {
                  this.submitDisabled = false;
                }
                clearInterval(this.pollingDataInterval);
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }, 20000);
    },
    resetFile() {
      if(this.pollingDataInterval){
        clearInterval(this.pollingDataInterval);
      }
      this.ruleForm.qualiAttachId = '';
      this.uploadMsg = '';
      this.submitDisabled = false;
      this.personal = true;
    },
    logout() {
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.$http
        .get(`vul/hsrc/vul/report/servlet/user/logout`, { headers: { 'x-csrf-token': Token } })
        .then(res => {
          if (res.status === 200 && res.data && res.data.data) {
            const outUrl = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/connect/v2/logout' : 'https://hnoauth-login-test-drcn.cloud.honor.com/connect/v2/logout';
            const redirectUrl = outUrl + '?response_type=token&access_token=' + encodeURIComponent(res.data.data) + '&next=' + encodeURIComponent('https://' + this.$baseU + '.honor.com/src/');
            window.location.href = redirectUrl;
            console.log('退出接口userLogout返回成功，res.status是200！');
          } else {
            console.log('退出接口userLogout返回失败，res.status不是200！');
          }
        })
        .catch(error => {});
    },
    openDialog() {
      this.cancelDialog = true;
    },
    cancelDialogMethod() {
      this.cancelDialog = false;
    },
    reportError(err) {
      const callError = JSON.parse(err.message);
      this.$message.error(callError.message || '上传失败，请稍后再试！');
    },
    // 上传成功钩子
    handlePreview(file) {
      this.ruleForm.headPictureUrl = `${file[0]}`;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 1 个文件，如果需要重新上传，请先删除原先文件`);
    },
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.$http
                .get('vul/hsrc/vul/report/services/user/getUserInfo?isDecrypt=true')
                .then(res => {
                  if (res.data && res.data.status === 200) {
                    this.ruleForm.email = res.data.data.emailStr;
                    this.ruleForm.qq = res.data.data.qqStr;
                    this.ruleForm.showRanking = res.data.data.showRanking;
                    this.originForm.qq = res.data.data.qqStr;
                    this.originForm.email = res.data.data.emailStr;
                    const tmp = res.data.data && res.data.data.qqStr;
                    if (!tmp && typeof tmp != 'undefined' && tmp !== 0) {
                      global.userInfo.qq = '';
                      this.ruleForm.qq = '';
                      this.originForm.qq = '';
                    }
                    this.isEdit = false;
                    this.dialogVisible = false;
                    this.$refs.ruleForm.clearValidate();
                  }
                })
                .catch(error => {
                  console.log(error);
                });
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    handleClose: function() {
      this.$router.push({ path: '/' });
    }, //限制输入特殊字符
    loginHandleClose: function() {
      this.$router.push({ path: '/' });
    },
    // btKeyDown: function(e) {
    //   e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownQQ: function(e) {
    //   this.ruleForm.qq = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownDisplayName: function(e) {
    //   this.ruleForm.displayName = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownSignature: function(e) {
    //   this.ruleForm.signature = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownTeam: function(e) {
    //   this.ruleForm.team = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownEmail: function(e) {
    //   this.ruleForm.email = e.target.value.replace(/[`~!#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // btKeyDownHomePage: function(e) {
    //   this.ruleForm.homePage = e.target.value.replace(/[`~!#$%^&*()_\-+=<>?"{}|,\;'\\[\]·~！#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
    // },
    // 查询个人信息
    getUserInfo: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res.data && res.data.status === 200) {
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount);
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount);
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount);
              global.userInfo = res.data.data;
              this.userInfoVO = res.data.data;
              this.getDataUrl();
              global.userInfo.displayName = res.data.data.displayName;
              global.this_info = this;
              this.ruleForm = res.data.data || {};
              if(res.data.data.docName)
              this.fileData.push({
                name:res.data.data.docName
              })
              const tmp = res.data.data && res.data.data.qq;
              if (!tmp && typeof tmp != 'undefined' && tmp !== 0) {
                global.userInfo.qq = '';
                this.ruleForm.qq = '';
              }
              this.originForm = Object.assign({}, global.userInfo);
              if (global.userInfo.headPictureUrl) {
                this.ruleForm.headPictureUrl = global.userInfo.headPictureUrl;
              }
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
          .then(res => {
            that.xCsrfToken = { 'x-csrf-token': res['headers']['x-csrf-token'] };
            window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    selectHandle: (index, indexPath) => {
      const that = this;
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    onEdit: function() {
      // const s = new Promise((resolve, reject) => {
      //   this.$http
      //     .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } }, {})
      //     .then(res => {
      //       // 接口直接返回布尔值，false时为未签名，弹出签名窗
      //       if (!res.data) {
      //         this.dialogVisible = true;
      //       } else {
              // 为true时，为签名验证已过，不需要签名
              this.$http
                .get('vul/hsrc/vul/report/services/user/getUserInfo?isDecrypt=true')
                .then(res => {
                  if (res.data && res.data.status === 200) {
                    this.ruleForm.email = res.data.data.emailStr;
                    this.ruleForm.qq = res.data.data.qqStr;
                    this.ruleForm.showRanking = res.data.data.showRanking;
                    this.originForm.qq = res.data.data.qqStr;
                    this.originForm.email = res.data.data.emailStr;
                    const tmp = res.data.data && res.data.data.qqStr;
                    if (!tmp && typeof tmp != 'undefined' && tmp !== 0) {
                      global.userInfo.qq = '';
                      this.ruleForm.qq = '';
                      this.originForm.qq = '';
                    }
                    this.isEdit = false;
                    this.editFlag = false;
                    this.$refs.ruleForm.clearValidate();
                  }
                })
                .catch(error => {
                  console.log(error);
                });
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error);
      //     });
      // });
    },
    //点击修改按钮
    onSubmit: function(form) {
      this.$refs[form].validate(function(valid, validObj) {
        if (validObj && Object.keys(validObj).length === 1 && validObj['qq'] && validObj['qq'].length) {
          if (global.this_info.originForm.qq === global.this_info.ruleForm.qq) {
            this.$refs.ruleForm.clearValidate();
            const params = global.this_info && global.this_info.objNotEqual(global.this_info.originForm, global.this_info.ruleForm);
            const aLen = Object.keys(params).length;
            if (aLen === 0) {
              console.log('未作修改1');
              global.this_info.$message.warning('未作修改！');
            } else {
              global.this_info && global.this_info.editUserInfo(params);
            }
          }
        }
        if (valid) {
          const params = global.this_info && global.this_info.objNotEqual(global.this_info.originForm, global.this_info.ruleForm);
          const aLen = Object.keys(params).length;
          if (aLen === 0) {
            console.log('未作修改2');
            global.this_info.$message.warning('未作修改！');
          } else {
            global.this_info && global.this_info.editUserInfo(params);
          }
        } else {
          console.log('error submit!!');
          return true;
        }
      });
    },
    // 修改个人资料
    editUserInfo: function(params) {
      let msgKey = '';
      Object.keys(params).forEach((value, key) => {
        if(null == params[value] || '' === params[value]){
          msgKey = value;
        }
      });
      if('' !== msgKey){
        this.$message.warning(this.nullMsg[msgKey]);
        return;
      }
      const Token = window.sessionStorage.getItem('x-csrf-token');
      if (params.qq === '') {
        params.qq = null;
      }
      const s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/user/editPersonalInfo', params, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            // console.log(res); //获取数据
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res.data && res.data.status === 200) {
              global.this_info.delWarnning = true;
              global.this_info.success = true;
              global.this_info.getUserInfo();
              global.this_info.isEdit = true;
              setTimeout(() => {
                window.location.reload();
              }, 50);
            } else {
              global.this_info.success = false;
            }
            setTimeout(() => {
              global.this_info.delWarnning = false;
            }, 2000);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 比较两个对象,取出value不同的
    objNotEqual: (oldParam, newParam) => {
      const c = {};
      for (const key in oldParam) {
        if(null == oldParam[key] && '' === newParam[key]){
          continue;
        }
        if (oldParam[key] !== newParam[key]) {
          c[key] = newParam[key];
        }
      }
      return c;
    },
    docNameHandle: function(val) {
      // eslint-disable-next-line no-magic-numbers
      if(val && val.length > 10){
        return val.substring(0, 10) + '……';
      }
      return val
    }
  }
};
</script>
<style lang="less" scoped>
.el-badge__content {
  border: none !important;
  margin-left: 5px;
  vertical-align: text-bottom;
}
.el-badge__content {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 60px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}

/deep/.xui-menu-item:hover {
  border-left: solid 0.3rem #409eff !important;
  background-color: #eee !important;
  color: #409eff !important;
}
/deep/.xui-button.is-round {
  background: #409eff;
  border-color: #409eff;
  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
  }
}

/deep/.dialog-content {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  text-align: center !important;
  font-size: 1rem;
  .img-status {
    width: 6rem;
  }
}
/deep/.upload-headPicture-btn {
  position: relative !important;
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}
.login-dialog-cancel {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}

// 20220812界面改版需求新增
.user-center__info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 50px;
  border-bottom: 1px solid var(--src-color-secondary-light5);
}

.user-center__info-portrait {
  display: flex;
  align-items: center;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
}

.user-center__info-pic {
  display: inline-block;
  width: 84px;
  height: 84px;
  line-height: 84px;
  border-radius: 50%;
}

.user-center__info-pic--default {
  font-size: var(--src--text-size-large-extra10);
  background: var(--src-bg-color-dark1);
  text-align: center;
  color: var(--src-text-color-white);
}

.user-center__info-button--default {
  width: 100%;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  background-color: var(--src-bg-color-blue-dark1);
  border-radius: 4px;
  font-size: var(--src--text-size-default);
  color: #fff;
}

.user-center__info-portrait-upload {
  position: relative;
  padding-bottom: 20px;
  width: 84px;
}

/deep/.user-center__info-portrait-upload .xui-upload {
  width: 100%;
}

/deep/.user-center__info-portrait-upload .xui-upload-list__item {
  width: 150px;
}

.user-center__info-portrait-tips {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-secondary);
  white-space: nowrap;
}
.user-center__info-item-tips {
  position: absolute;
  left: 100px;
  top: -1px;
  line-height:18px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-secondary);
  white-space: normal;
  .upload-msg {
    color: green;
  }
}

.user-center__info-portrait-txt {
  margin-left: 20px;
  cursor: pointer;
  &:after {
    display: inline-block;
    content: '';
    width: 1px;
    height: var(--src--text-size-large-extra1);
    margin: 0 10px;
    background-color: var(--src-color-primary-dark5);
    vertical-align: -3px;
  }
}

.user-center__info-portrait-txt--inner {
  font-size: var(--src--text-size-large);
  color: var(--src-bg-color-blue-dark1);
  font-weight: var(--src-text-weight-dark1);
}

.user-center__info-button--primary {
  width: 82px;
  height: 24px;
  line-height: 24px;
  background: var(--src-bg-color-blue-dark1);
  border-radius: 18px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white);
  text-align: center;
  font-weight: var(--src-text-weight-light1);
}

.user-center__info-list {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 50px 0;
}

.user-center__info-item {
  display: flex;
  align-items: center;
  flex-basis: 50%;
  padding: 0 20px;
  margin-top: 15px;
  font-size: var(--src--text-size-default);
  &.is-overflow-hidden {
    overflow: hidden;
  }
  &:nth-last-child(1){
   flex-basis: 90%; 
  }
}


.user-center__info-item-title {
  font-size: var(--src--text-size-middle);
  width: 105px;
  margin-right: 10px;
  color: var(--src-color-secondary-light6);
  text-align: right;
  font-weight: var(--src-text-weight-light1);
  &.is-required:before {
    content: '*';
    margin-right: 4px;
    color: var(--src-bg-color-red-light1);
  }
}

.user-center__info-item-content {
  flex: 1;
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
  &.is-overflow-hidden {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

/deep/.user-center__info-list .xui-form-item {
  margin-bottom: 0;
}

/deep/.user-center__info-list .xui-form-item .xui-input__inner {
  height: 40px;
  line-height: 40px;
}

.user-center__info-submit {
  display: flex;
  justify-content: center;
  padding: 0 50px;
  margin-top: 30px;
}

.user-center__info-button--bottom {
  height: 36px;
  line-height: 34px;
  margin-top: 30px;
  padding: 0 32px;
  background: var(--src-bg-color-blue-dark1) !important;
  border-radius: 5px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white) !important;
  font-weight: var(--src-text-weight-light1);
}
/deep/.report__form-button--upload{
  height: 46px;
  line-height: 44px;
  padding:0 13px;
  background: var(--src-text-color-white-dark2);
  border: 1px solid var(--src-color-secondary-light4);
  border-radius: 4px;
  font-size: var(--src--text-size-medium);
  color: var(--src-color-primary-dark4);
  font-weight: var(--src-text-weight-light1);
}
.qualiAttach_xui-link{
  margin-left:5px;
  margin-top:5px;
  display:inline-block;
}
.dialog_span-icon{
  color: #f5a623;
  font-size: 32px;
}
.attachment_uploadFile_xui-link{
  margin-left:5px;
  margin-top:5px;
  display:inline-block;
}
.upload_width{
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/info/usercenterInfo.vue